/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReusableTable from '../../ReusableTable/ReusableTable';
import Select from "react-select";
import styles from './QualityObservation.module.css';
import './QualityObservation.css';
import axios from 'axios';
import { usePopupManager } from "../../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../../constants";
import config from '../../../config/config';
import DashboardSection from '../../DashboardContainer/DashboardSection';
import DomainTile from '../../DomainTile/DomainTile';

const { API_BASE_URL } = config;

const QualityObservationDeatil = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    monthData: null,
  };

  const { showPopup } = usePopupManager();
  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState();
  
  const [hasApplied, setHasApplied] = useState(false);
  const [filters, setFilters] = useState(initialFilters);
  // console.log("filters obser------:",filters)
  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  const [entity, setEntity] = useState([]);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
//   const [quarter, setQuarter] = useState(quarterOptions[0]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1); 
  const itemsPerPage = 100;
  const [selectedPage, setSelectedPage] = useState();
  const [data, setData] = useState([]);
  const [dataCSV, setDataCSV] = useState([]);

  const [startPage, setStartPage] = useState(0);
  const [endPage, setEndPage] = useState(100);

  
  const [dataLoading, setdataLoading] = useState(false);

  useEffect(() => {
    fetchData(filters);
  }, []);

  const fetchData = (filters) => {
    // console.log("Fetching with", filters);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '20px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '50px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const columns = [
    { header: "Entity", accessor: "entity" },
    { header: "Month", accessor: "date_month" },
    { header: "Observation", accessor: "observation" },
    { header: "RCA", accessor: "rca" },
    { header: "CAPA(Target Date)", accessor: "capa_target_date" },
    { header: "CAPA Implememntation Date", accessor: "capa_implementation_date" }
  ];
 
  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/Quality-entity`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setEntityOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/Quality-filters`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setYearOptions(response.data[0].year);
        setMonthOptions(response.data[0].month);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleMonthChange = (selected) => {
    setMonth(selected);
    setFilters(prev => ({ ...prev, monthData: selected }));
  };

  const handleApply = () => {
    const entity_data = entity?.map((m) => m?.value) || [];
    const year_data = year?.map((m) => m?.value) || [];
    const month_data = month?.map((m) => m?.value) || [];
    const page = selectedPage || 1;
    const limit = itemsPerPage;
    const offset = (page - 1) * limit;

    // if (entity_data && entity_data.length === 0) {
    //     showPopup({
    //       type: MESSAGE_TYPE.INFORMATION,
    //       contextText: MESSAGE_TYPE.INFORMATION,
    //       info: "Please select entity.",
    //     });
    //     return;
    //   }

    // setIsLoading(true);
    const fetchTreadmarkData = async () => {
    setIsLoading(true);
      try {
        const response = await axios.post(`${API_BASE_URL}/api/Quality-observationdetail`,
          {
            selectedentity: entity_data,
            selectedyear: year_data,
            selectedmonth: month_data,
            start: startPage,
            end: endPage,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );

        setShowDashboard(true);
        setData(response.data.data)
        setTotalRecords(response.data.data_count)
        setDataCSV(response.data.dataCSV);
      } catch (error) {
        console.error('Error fetching trademark data:', error);
      } finally {
        setdataLoading(false);
        setIsLoading(false);
      }
    };

    fetchTreadmarkData();
  };

  const handleCSVDownload = () => {
  
    // CSV Header
    const csvHeader = columns.map(col => col.header).join(',');
  
    // Data rows
    const csvRows = dataCSV.map(row =>
      columns
        .map(col =>
          `"${String(row[col.accessor] ?? '').replace(/"/g, '""')}"`
        )
        .join(',')
    );
  
    // Final CSV
    const csvContent = [csvHeader, ...csvRows].join('\n');
  
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Quality_Observation.csv';
    link.click();
  };

  const handleReset = () => {
    setShowDashboard(false);
    setHasApplied(false);
  
    setEntity([]);
    setYear([]);
    setMonth([]);
  
    setSelectedPage(1);
    setStartPage(0);
    setEndPage(100);
  
    setData([]);
    setDataCSV([]);
    setTotalRecords(0);
  };

  useEffect(() => {
    fetchEntityOptions();   
    fetchYearOptions();
  }, []);

const handlePageChange = (page) => {
    setHasApplied(true)
    setSelectedPage(page);
    let endPageVal = page * 100
    let startPageVal = endPageVal - 99

    setStartPage(startPageVal)
    setEndPage(endPageVal)
    // console.log(`Selected page: ${page}`);

  };

  useEffect(() => {
    if (hasApplied) {
      handleApply();
    }
  }, [selectedPage,hasApplied]);

  useEffect(() => {
    if (entityOptions.length && yearOptions.length && monthOptions.length) {
      let shouldApply = false;

      if (filters.entityData) {
        const ent = entityOptions.find(
          (opt) => opt.value === filters.entityData?.map((m) => m?.value) || []
        );
        if (ent) {
          setEntity(filters.entityData);
          shouldApply = true;
        }
      }

      if (filters.yearData && filters.yearData.length > 0) {
          const yr = yearOptions.filter(opt =>
              filters.yearData.some(m => (m?.value ?? m) === opt.value)
          );
          if (yr.length > 0) setYear(yr);
        }

      if (filters.monthData && filters.monthData.length > 0) {
          const mon = monthOptions.filter(opt =>
              filters.monthData.some(m => m.value === opt.value)
          );
          if (mon.length > 0) setMonth(mon);
        }

      if (shouldApply) {
        // console.log(shouldApply)
        setHasApplied(true);
      }
    }
  }, [entityOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied) {
      handleApply();
    }
  }, [selectedPage,hasApplied]);
  
  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity</label>
            <div className={styles.filter_select_wrapper}>
            <Select
                value={entity}
                isMulti={true}
                closeMenuOnSelect={false}
                // onChange={setEntity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
            <Select
                value={year}
                isMulti={true}
                closeMenuOnSelect={false}
                // onChange={setYear}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
            <Select
                value={month}
                isMulti={true}
                // onChange={setMonth}
                onChange={handleMonthChange}
                closeMenuOnSelect={false}
                options={monthOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">Apply</button>
            <button onClick={handleReset} className="btn reset-btn">Reset</button>
          </div>
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
            
          </div>
        </div>
      )}
      {showDashboard && (
        <>
          <DomainTile title='Quality Observation Details' showBackButton={true} mainPagePath='/Quality' detailState = {filters}/>
          <DashboardSection showDetailView={false} infoIcondata={"Manual CSV Data"}>
            {/* <ReusableTable
              data={filteredData}
              columns={columns}
              itemsPerPage={itemsPerPage} onPageChange={handlePageChange} totalRecords={totalRecords}
            /> */}
                <ReusableTable
                  data={data} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={totalRecords} handleCSVDownload={handleCSVDownload} dataLoading={dataLoading}
                />
          </DashboardSection>
        </>
      )}
    </>
  );
};

export default QualityObservationDeatil;
